/**
 * @generated SignedSource<<879f7f2866ad870ac60c8f5a2158cdab>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RemoveRecipientsFromListInput = {
  emailAddresses?: ReadonlyArray<string> | null | undefined;
  phoneNumbers?: ReadonlyArray<string> | null | undefined;
  recipientListId: string;
  respondentIds?: ReadonlyArray<string> | null | undefined;
};
export type RemoveRecipientsFromListMutation$variables = {
  input: RemoveRecipientsFromListInput;
};
export type RemoveRecipientsFromListMutation$data = {
  readonly removeRecipientsFromList: {
    readonly success: boolean | null | undefined;
    readonly updatedCaches: boolean | null | undefined;
  };
};
export type RemoveRecipientsFromListMutation = {
  response: RemoveRecipientsFromListMutation$data;
  variables: RemoveRecipientsFromListMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RemoveRecipientsFromListPayload",
    "kind": "LinkedField",
    "name": "removeRecipientsFromList",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updatedCaches",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RemoveRecipientsFromListMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RemoveRecipientsFromListMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b7f54861c39cd07792e02c97f7984045",
    "id": null,
    "metadata": {},
    "name": "RemoveRecipientsFromListMutation",
    "operationKind": "mutation",
    "text": "mutation RemoveRecipientsFromListMutation(\n  $input: RemoveRecipientsFromListInput!\n) {\n  removeRecipientsFromList(input: $input) {\n    success\n    updatedCaches\n  }\n}\n"
  }
};
})();

(node as any).hash = "2e2588576b5ca5a80bba42651ed3319c";

export default node;
